'use es6';

import PortalIdParser from 'PortalIdParser';
import { connect } from 'react-redux';
import ThreadHistory from '../components/ThreadHistory';
import { getMessagesList } from '../selectors/getMessagesList';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
import { getSendersMap } from '../selectors/getSendersMap';
import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
import { buildError } from 'conversations-error-reporting/error-reporting/builders/buildError';
const mapStateToProps = state => {
  let messagesList;
  try {
    messagesList = getMessagesList(state);
  } catch (error) {
    reportError({
      error: buildError(`ConnectedChatHistoryGetMessagesList selector threw: ${error.message}`, error)
    });
    throw error;
  }
  return {
    coloring: getColoring(state),
    messagesList,
    portalId: PortalIdParser.get(),
    senders: getSendersMap(state)
  };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(ThreadHistory);